import { render, staticRenderFns } from "./ConvenioShow.vue?vue&type=template&id=63bc32fc"
import script from "./ConvenioShow.vue?vue&type=script&lang=js"
export * from "./ConvenioShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports